import { colors } from '@material-ui/core';

export default {
  root: {
    padding: '5px 15px'
  },
};
